import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Header from './Header';

const LoginPage = ({ onLogin }) => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Simple demo authentication
    const storedUser = JSON.parse(localStorage.getItem('demoUser') || '{}');
    if (formData.email === storedUser.email && formData.password === storedUser.password) {
      onLogin(formData.email);
      navigate('/dashboard');
    } else {
      alert('Invalid credentials. Please register first or use correct email/password.');
    }
  };

  const handleWalletLogin = () => {
    navigate('/new-login');
  };

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
      <Header />

      {/* Main Content */}
      <main style={{ padding: '60px 0', backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.58), rgba(255, 255, 255, 0.9)),url("/images/living-room-scandinavian-interior-design.jpg")`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        minHeight:'91vh' }}>
        <div className="container">
          <div className="card">
            <h2 className="text-center" style={{ marginBottom: '40px', color: '#333' }}>
              Login
            </h2>
            
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="email">Email *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  disabled
                  readOnly
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="password">Password *</label>
                <div style={{ position: 'relative' }}>
                  <input
                    type={showPassword ? "text" : "password"}
                    id="password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    required
                    style={{ paddingRight: '50px' }}
                    disabled
                    readOnly
                  />
                  <button
                    type="button"
                    onClick={togglePasswordVisibility}
                    style={{
                      position: 'absolute',
                      right: '10px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      fontSize: '16px',
                      color: '#666',
                      padding: '5px'
                    }}
                  >
                    {showPassword ? '👁️' : '👁️‍🗨️'}
                  </button>
                </div>
              </div>
              
              <div className="login-options">
                <button type="submit" className="btn btn-primary" disabled>
                  Login
                </button>
                
                <button 
                  type="button" 
                  onClick={handleWalletLogin}
                  className="btn btn-wallet"
                >
                  <img src="/images/eudi-wallet.svg" alt="EUDI Wallet" height={24}/>
                </button>
              </div>
            </form>
            
            <div style={{ 
              textAlign: 'center', 
              marginTop: '30px',
              padding: '20px',
              backgroundColor: '#f8f9fa',
              borderRadius: '8px'
            }}>
              <p style={{ color: '#666', marginBottom: '10px' }}>
                Don't have an account?
              </p>
              <Link to="/register" style={{ color: '#90c695' }}>
                Register Now
              </Link>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default LoginPage;

